import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getWallId, isAppleSafari } from '../../../../utils';
import { SHOW_DEMO_POST } from '../../../../actions/wallsAction';
import withRouter from '../../../CommonComponents/WithRouter';
import { getFontVariants, getThemeSettings } from "../../../../actions/appsMoreAction";
import SelectLayout from "./SelectLayout/SelectLayout";
import "./personalize.css";
import Fonts from '../../../CommonComponents/Fonts';
import { GET_WIDGET_WALL_DATA } from '../../../../reducers/keys';
import Swal from 'sweetalert2';
import PopupUpload from './LayoutSettings/PopupUpload';
import ThemeRender from './ThemeRender';
import { UPPY_BUCKET_URL } from '../../../../actions/constant';
import ImageUpload from './LayoutSettings/Banner/ImageUpload';
import { checkTheme, getWidgetWallData } from '../../../../actions/wallDataAction';
import { Helmet } from "react-helmet";
import { toggleAddFeedsSection_D, toggleManageSection_D, togglePlanSection_D } from '../../../../actions/showDisplayModalAction';
import moment from 'moment';
import isEqual from 'lodash/isEqual';
import { FontAwesomeIcon } from '../../../CommonComponents/AssetsHelper';
import { Button } from 'react-bootstrap';

const Personalize = (props) => {
  const { wallData } = props;
  return wallData && Object.keys(wallData).length > 0 ? <PE {...props} key={wallData.wallID} /> : null;
}

class PE extends Component {
  constructor(props) {
    super(props);
    this.state = { debounceTimeout: null, newSettingUpdate: false, activesettingLayout: 0, banner: [], background: [], getThemeSetting: [], CustomCss: [], cardStyle: [], bannerPrevius: [], backgroundPrevius: [], getThemeSettingPrevius: [], UgcSettings: [], ugcSettingsPrevius: [], CustomCssPrevius: [], cardStylePrevius: [], postAnimation: [], loading: false, demoWall: null, font: false, layoutError: false, themeUpdate: 0, themeRender: 0, renderKey: 1, discardChanges: false, themeSettingStatus: false, onUploadPop: false, sizeError: '', popStatus: '', onUppyPop: false, onUppyPopStatus: '', openSidebar: false, reRendor: 0, product: 0, activeLayoutId: 0, postData: [], backToSnapUp: false, reloadLivePreview: false, }
  }

  componentDidMount() {
    const { getFontVariants, getWidgetWallData, wallData } = this.props;

    if (wallData?.wall?.Personalization?.ThemeRule?.id) this.updatewallData();
    else getWidgetWallData(localStorage.getItem("ownerId"), localStorage.getItem('wallId'), this.updatewallData)

    getFontVariants();
    this.onLoad();

    if (localStorage.getItem('sort-option')) {
      localStorage.removeItem('sort-option');
      setTimeout(() => this.setState({ activesettingLayout: 5 }), 1000);
    } else if (window.location.href.includes('tab=reactions')) this.setState({ activesettingLayout: 8 })

    // this.setState({ product: localStorage.getItem('activeProduct') == 1 ? 1 : 0 })
    setTimeout(() => this.setState({ font: true }), 10000);
    window.addEventListener('message', this.handleMessage);
  }


  handleMessage = (event) => {
    if (event?.origin.includes("socialwalls.com")) {
      const { dispatch, navigate } = this.props
      if (event.data === 'ShowDemoWall') { this.onShowDemoPost(1) }
      else if (event.data === 'HideDemoWall') { this.onShowDemoPost(0) }
      else if (event.data === "AddFeed") { dispatch(toggleAddFeedsSection_D(true)); navigate(`/wall/index/${localStorage.getItem('wallId')}`) }
      else if (event.data === "ManageFeed") { dispatch(toggleManageSection_D(true)); navigate(`/wall/index/${localStorage.getItem('wallId')}`) }
      else if (event.data === "ChangeDateRange") { navigate(`/wall/personalize/${localStorage.getItem('wallId')}?tab=changeDateRange`) }
      else if (event.data === "Moderation") { navigate(`/moderation/index/${localStorage.getItem('wallId')}`) }
      else if (event.data === "ChangeTheme") { this.setState({ activesettingLayout: 0 }); navigate(`/wall/personalize/${localStorage.getItem('wallId')}`) }
    }
  }


  componentDidUpdate(previusProps, previusState) {
    const { wallData, checkNewTheme } = this.props;
    const themeId = wallData ? wallData.wall?.Personalization?.ThemeRule.themeId : null;
    const wallId = localStorage.getItem('wallId');

    if (previusState.cardStyle.themeId != this.state.cardStyle.themeId) {
      if ([74, 76, 77].includes(this.state.cardStyle.themeId)) { setTimeout(() => this.previewProduct(), 2000); }
    }

    if (previusProps.wallData != wallData) {
      this.setState({ themeUpdate: Math.random(), activesettingLayout: 0 }, this.updatewallData)
    }

    if (wallData && wallData.wallId == wallId && themeId && themeId < 62) {
      checkNewTheme({ wallId: wallData.wallId, themeId, status: 1, ownerId: wallData.wallOwner }, wallData, 62, this.onLoad);
    }

    if (localStorage.getItem('openQrSetting')) {
      this.setState({ activesettingLayout: 9, backToSnapUp: true })
      localStorage.removeItem('openQrSetting')
    }
    if (previusProps.wallData?.wall?.Personalization?.demoWall !== this.props.wallData?.wall?.Personalization?.demoWall) {
      this.onShowDemoPost(this.props.wallData?.wall?.Personalization?.demoWall)
    }
    if (window.location.href.includes('tab=reactions') && this.state.activesettingLayout != 8) {
      this.setState({ activesettingLayout: 8 })
    }
    if (window.location.href.includes('tab=snapup') && this.state.activesettingLayout != 9) {
      this.setState({ activesettingLayout: 9 })
    }

    if (window.location.href.includes('tab=changeDateRange') && this.state.activesettingLayout != 5) {
      this.setState({ activesettingLayout: 5 })
    }
  }

  componentWillUnmount() {
    window.clearData && window.clearData();
    var elements = document.querySelector(".uppy-Dashboard-close");
    if (elements && elements != null) {
      elements.removeEventListener('click', this.setState({ onUploadPop: false, onUppyPop: false }), false);
    }
    setTimeout(() => this.showDiscardPop(0, this.state.activesettingLayout, 2), 1000);
    window.removeEventListener('message', this.handleMessage);
  }


  updatewallData = () => {
    const { wallData } = this.props;
    if (!wallData?.wall?.Personalization?.ThemeRule?.id) return;
    const Personalization = wallData.wall.Personalization;
    const CustomBanner = wallData.wall.CustomBanner;
    const UgcSettings = wallData.wall.UgcSettings;

    const cardStyleObj = {
      themeId: Personalization.ThemeRule.themeId < 62 ? 62 : Personalization.ThemeRule.themeId,
      id: Personalization.ThemeRule.id,
      autoPlay: Personalization.ThemeRule.autoPlay,
      backgroundColor: Personalization.ThemeRule.backgroundColor,
      blurBackground: Personalization.ThemeRule.blurBackground,
      blurColor: Personalization.ThemeRule.blurColor,
      font: Personalization.ThemeRule.font,
      fontSizeDecorate: Personalization.ThemeRule.fontSizeDecorate,
      fontSizeNormal: Personalization.ThemeRule.fontSizeNormal,
      mobileColumn: Personalization.ThemeRule.mobileColumn,
      numberOfPosts: Personalization.ThemeRule.numberOfPosts,
      popupContent: Personalization.ThemeRule.popupContent,
      slideDuration: Personalization.ThemeRule.slideDuration,
      slidePost: Personalization.ThemeRule.slidePost,
      slideDelay: Personalization.ThemeRule.slideDelay,
      multiRow: Personalization.ThemeRule.multiRow ? Personalization.ThemeRule.multiRow : 2,
      numberOfCoumn: Personalization.ThemeRule.numberOfCoumn ? Personalization.ThemeRule.numberOfCoumn : 5,
      postFeatured: Personalization.ThemeRule.themeId < 62 ? Personalization.postFeatured : Personalization.ThemeRule.postFeatured,
      trimcontent: Personalization.ThemeRule.themeId < 62 ? 1 : Personalization.ThemeRule.trimcontent,
      link_font: Personalization.ThemeRule.link_font,
      css_font: Personalization.ThemeRule.css_font,
      font_varient: Personalization.ThemeRule.font_varient,
      cardColor: Personalization.ThemeRule.cardColor,
      fontColor: Personalization.ThemeRule.fontColor,
      authorColor: Personalization.ThemeRule.authorColor,
      iconColor: Personalization.ThemeRule.iconColor,
      cardType: Personalization.ThemeRule.cardType,
      iconType: Personalization.ThemeRule.iconType,
      socialAction: Personalization.ThemeRule.socialAction,
      shareOption: Personalization.ThemeRule.shareOption,
      hideContent: Personalization.ThemeRule.hideContent,
      fontSize: Personalization.ThemeRule.fontSize,
      captionFontWeight: Personalization.ThemeRule.captionFontWeight,
      authorFont: Personalization.ThemeRule.authorFont,
      authorFontVariant: Personalization.ThemeRule.authorFontVariant,
      linkfontAuthor: Personalization.ThemeRule.linkfontAuthor,
      showHideSocialIcon: Personalization.ThemeRule.showHideSocialIcon,
      spacing: Personalization.ThemeRule.spacing ? Personalization.ThemeRule.spacing : 0,
      borderRadius: Personalization.ThemeRule.borderRadius ? Personalization.ThemeRule.borderRadius : 0,
      captionStatus: Personalization.ThemeRule.CaptionStatus,
      padding: Personalization.ThemeRule.padding ? Personalization.ThemeRule.themeId < 62 ? 10 : Personalization.ThemeRule.padding : 0,
      postTime: Personalization.ThemeRule.postTime,
      postAuthor: Personalization.ThemeRule.postAuthor,
    };

    const getThemeSetting = {
      custom_lan_data: Personalization.custom_lan_data,
      demoWall: Personalization.demoWall,
      feeds: Personalization.feeds,
      filterEnableStatus: Personalization.filterEnableStatus,
      filter_type: Personalization.filter_type,
      loader_colors: Personalization.loader_colors,
      loader_type: Personalization.loader_type,
      mobilePopup: Personalization.mobilePopup,
      onsite_settings: Personalization.onsite_settings,
      popupSlideShow: Personalization.popupSlideShow,
      popupSlideShowStatus: Personalization.popupSlideShowStatus,
      postFeatured: Personalization.ThemeRule.themeId < 62 ? Personalization.postFeatured : Personalization.ThemeRule.postFeatured,
      postTime: Personalization.postTime,
      tag_filter: Personalization.tag_filter,
      tag_filter_status: Personalization.tag_filter_status,
      textDecorateStatus: Personalization.textDecorateStatus,
      themeType: Personalization.themeType,
      trimContentStatus: Personalization.trimContentStatus,
      w_language: Personalization.w_language,
      wallId: Personalization.wallId,
      widgetTheme: Personalization.widgetTheme,
      autoScroll: Personalization.autoScroll,
      blurEffect: Personalization.blurEffect,
      carouselPost: Personalization.carouselPost,
      cta: { status: Personalization.ctaStatus, color: Personalization.ctaTextColor, background: Personalization.ctaButtonColor, url: "", txt: "" },
      // API NEW KEYS END -------------
      ctaStatus: Personalization.ctaStatus,
      hashtag_all: Personalization.hashtag_all,
      hashtag_background_color: Personalization.hashtag_background_color,
      hashtag_background_status: Personalization.hashtag_background_status,
      hashtag_color: Personalization.hashtag_color,
      hashtag_feed: Personalization.hashtag_feed,
      hashtag_highlight: 1,
      signageTheme: Personalization.signageTheme,
      //numberOfCoumn:Personalization.ThemeRule.numberOfCoumn,
      autoUpdate: Personalization.autoUpdate,
      duplicatePostId: Personalization.duplicatePostId,
      cssStatus: Personalization.cssStatus,
      css: Personalization.css,
      randomizePost: Personalization.randomizePost,
      loadMoreStatus: Personalization.loadMoreStatus,
      autoScrollStatus: Personalization.autoScrollStatus,
      postText: Personalization.postText,
      filterStatus: Personalization.filterStatus,
      trimcontent: Personalization.ThemeRule.themeId < 62 ? 1 : Personalization.ThemeRule.trimcontent,
      retweetexclude: Personalization.retweetexclude,
      popupSlideSpostTexthow: Personalization.popupSlideSpostTexthow,
      fitRow: Personalization.fitRow,
      textDecorate: Personalization.textDecorate,
      slidePost: Personalization.ThemeRule.slidePost,
      publicAccess: Personalization.publicAccess,
      showHideOlderPost: Personalization.showHideOlderPost,
      numberOfPosts: Personalization.ThemeRule.numberOfPosts,
      slideDuration: Personalization.ThemeRule.slideDuration,
      minimumPostWidth: Personalization.minimumPostWidth,
      // padding: Personalization.padding ? Personalization.ThemeRule.themeId < 62 ? 10 : Personalization.padding : 0,
      transition: Personalization.ThemeRule.transition,
      showHideOldPost: Personalization.showHideOldPost ? Personalization.showHideOldPost : moment().unix(),
      customUrl: Personalization.customUrl,
      animateBackground: Personalization.animateBackground,
      hideUrls: Personalization.hideUrls,
      playFullVideo: Personalization.playFullVideo,
      timeForPopup: Personalization.ThemeRule.timeForPopup ? Personalization.ThemeRule.timeForPopup : 0,
      blurColor: Personalization.ThemeRule.blurColor,
      blurBackground: Personalization.ThemeRule.blurBackground,
      slideDelay: Personalization.slideDelay,
      transitionStatus: Personalization.ThemeRule.transitionStatus,
      multiRow: Personalization.ThemeRule.multiRow,
      scrollDelay: Personalization.scrollDelay ? Personalization.scrollDelay : 50,
      columnCount: Personalization.ThemeRule.columnCount ? Personalization.ThemeRule.columnCount : 1,
      interactive: Personalization.interactive,
      carouselPopupAutoPlay: Personalization?.carouselPostAutoPlay ?? 0,
    }

    const themeBanner = {
      BannerImage: Personalization.BannerImage,
      CustomBannerImage: CustomBanner.CustomBannerImage,
      LogoImage: CustomBanner.LogoImage,
      status: CustomBanner.status,
      bannerType: CustomBanner.bannerType,
      transparent: CustomBanner.transparent || 0,
      background_color: CustomBanner.background_color,
      background_color_two: CustomBanner.background_color_two,
      backgroundImage: '',
      subTitle: CustomBanner.subTitle,
      subTitle_font_color: CustomBanner.subTitle_font_color,
      subtitle_link_font: CustomBanner.subtitle_link_font,
      subtitle_css_font: CustomBanner.subtitle_css_font ? CustomBanner.subtitle_css_font : 'None',
      subtitle_font_varient: CustomBanner.subtitle_font_varient,
      subTitle_font_size: CustomBanner.subTitle_font_size || 14,
      title: CustomBanner.title,
      title_font_color: CustomBanner.title_font_color,
      title_link_font: CustomBanner.title_link_font,
      title_css_font: CustomBanner.stitle_css_font ? CustomBanner.stitle_css_font : 'Default',
      title_font_varient: CustomBanner.title_font_varient,
      title_font_size: CustomBanner.title_font_size || "20",
      social_icon_status: CustomBanner.social_icon_status,
      social_icons: CustomBanner.social_icons ? CustomBanner.social_icons : "1,2,3",
      social_icon_size: CustomBanner.social_icon_size || 24,
      social_icon_color_status: CustomBanner.social_icon_color_status || 0,
      social_icon_color: CustomBanner.social_icon_color || "#fbfbfb",
      facebook_url: CustomBanner.facebook_url || "",
      twitter_url: CustomBanner.twitter_url || "",
      instagram_url: CustomBanner.instagram_url || "",
      banner_height: CustomBanner.banner_height > 0 ? parseInt(CustomBanner.banner_height) : 100,
      banner_position: CustomBanner.banner_position > 0 ? CustomBanner.banner_position : "1",
      customBannerStatus: CustomBanner.status,
      bannerUpdate: CustomBanner.status || (Personalization.BannerImage && Personalization.BannerImage.status) ? 1 : 0,
      bannerChange: CustomBanner.bannerType ? 1 : 0
    }

    const background = {
      transparent: Personalization.ThemeRule.transparent,
      image: Personalization.BackgroundImage.newName,
      color: Personalization.ThemeRule.backgroundColor,
    };

    const ugcSettings = {
      onsite_btn_icon: UgcSettings?.onsite_btn_icon,
      onsite_qr_code_status: UgcSettings?.onsite_qr_code_status,
      onsite_qr_code_btn_text: UgcSettings?.onsite_qr_code_btn_text,
      onsite_font_varient_btn: UgcSettings?.onsite_font_varient_btn,
      onsite_popup_title: UgcSettings?.onsite_popup_title,
      onsite_popup_sub_heading: UgcSettings?.onsite_popup_sub_heading,
      onsite_css_font_btn: UgcSettings?.onsite_css_font_btn,
      onsite_thank_fontSize: UgcSettings?.onsite_thank_fontSize,
      onsite_title: UgcSettings?.onsite_title,
      onsite_desc: UgcSettings?.onsite_desc,
      onsite_overlay_title: UgcSettings?.onsite_overlay_title,
      onsite_bg_image: UgcSettings?.onsite_bg_image,
      onsite_url_barcode: UgcSettings?.onsite_url_barcode,
      onsite_overlay_height: UgcSettings?.onsite_overlay_height,
      onsite_overlay_poisition: UgcSettings?.onsite_overlay_poisition,
      onsite_succ_msg: UgcSettings?.onsite_succ_msg,
      onsite_status: UgcSettings?.onsite_status,
      onsite_btn_txt: UgcSettings?.onsite_btn_txt,
      onsite_btn_color: UgcSettings?.onsite_btn_color,
      onsite_btn_txt_color: UgcSettings?.onsite_btn_txt_color,
      onsite_terms_url: UgcSettings?.onsite_terms_url,
      onsite_txt_css_font: UgcSettings?.onsite_txt_css_font,
      onsite_logo: UgcSettings?.onsite_logo,
      onsite_background_image: UgcSettings?.onsite_background_image,
      onsite_background_color: UgcSettings?.onsite_background_color,
      onsite_page_url: UgcSettings?.onsite_page_url,
      choose_content_category: UgcSettings?.choose_content_category,
      onsite_bg_color: UgcSettings?.onsite_bg_color,
      onsite_txt_color: UgcSettings?.onsite_txt_color,
      onsite_txt_font_variation: UgcSettings?.onsite_txt_font_variation,
      onsite_txt_font: UgcSettings?.onsite_txt_font,
      onsite_txt_font_size: UgcSettings?.onsite_txt_font_size,
      onsite_button_status: UgcSettings?.onsite_button_status,
      onsite_popup_btn_txt: UgcSettings?.onsite_popup_btn_txt,
      onsite_moderation: UgcSettings?.onsite_moderation,
      onsite_qrcode_img: UgcSettings?.onsite_qrcode_img,
      onsite_email_logo: UgcSettings?.onsite_email_logo,
      onsite_language: UgcSettings?.onsite_language
    }

    this.setState({
      banner: themeBanner,
      background: background,
      getThemeSetting: getThemeSetting,
      CustomCss: Personalization.css,
      cardStyle: cardStyleObj,
      UgcSettings: ugcSettings,
      bannerPrevius: themeBanner,
      backgroundPrevius: background,
      getThemeSettingPrevius: getThemeSetting,
      CustomCssPrevius: Personalization.css,
      cardStylePrevius: cardStyleObj,
      ugcSettingsPrevius: ugcSettings,
      demoWall: Personalization?.demoWall,
      errorCode: wallData?.error_code,
      errorData: wallData?.error,

    })

  }

  previewProduct = (status = 0) => this.setState({ product: status, themeUpdate: Math.random(), loading: true }, () => this.updateTheme(0, 1))

  onShowDemoPost = (status) => {
    const { params } = this.props;
    const { getThemeSetting } = this.state;
    const wallId = Object.keys(params).length > 0 ? params.wallID : getWallId();
    SHOW_DEMO_POST(status, wallId);
    this.reloadIfreame();
    this.setState({ getThemeSetting: { ...getThemeSetting, demoWall: status }, demoWall: status });
    this.updateTheme();
  }

  onLoad = () => { };

  removeData = () => {
    const socialScript = document.querySelectorAll(`script[data-js='social-wall']`);
    const socialCss = document.querySelectorAll(`link[data-css='social-wall']`);
    if (socialScript) socialScript.forEach(e => e.remove())
    if (socialCss) socialCss.forEach(e => e.remove())
  }


  themecardStyle = (data, parm = false) => {
    const { cardStyle, bannerPrevius, backgroundPrevius, getThemeSettingPrevius, CustomCssPrevius, cardStylePrevius, banner, } = this.state;

    const { wallData, updataWallData } = this.props;
    const random = Math.random()

    if (parm == 'theme') {

      let wallEditor = document.getElementsByClassName('wall-editor');
      wallEditor.innerHTML = "";

      const feedId = wallData.feeds.some((data) => data.networkId == 4);

      wallData['wall']['Personalization']['ThemeRule']['themeId'] = data.themeId;


      if (feedId && [65, 67, 68, 69, 73, 71].includes(data.themeId)) {
        this.setState({ layoutError: true, themeUpdate: data.themeId ? random : 0, themeRender: data.themeId ? random : 0, cardStyle: { ...cardStyle, ...data }, banner: { ...banner } })
      } else {
        this.setState({ themeUpdate: data.themeId ? random : 0, themeRender: data.themeId ? random : 0, banner: bannerPrevius, background: backgroundPrevius, getThemeSetting: getThemeSettingPrevius, CustomCss: CustomCssPrevius, loading: true, layoutError: false, discardChanges: true, cardStyle: { ...cardStyle, ...data }, banner: banner }, () => { this.updateTheme(1); updataWallData(wallData) })
      }
    } else {
      this.setState({ themeUpdate: data.themeId || [64, 67, 68, 69, 70, 71, 72, 73].includes(cardStyle.themeId) ? random : 0, discardChanges: true, cardStyle: { ...cardStyle, ...data }, banner: banner }, () => { this.updateTheme(); updataWallData(wallData) })
    }
  }

  themeBanner = (data, changes = true) => {
    const { banner } = this.state;
    this.setState({ banner: { ...banner, ...data }, discardChanges: changes }, this.updateTheme)
  }

  updateQrSetting = (data, changes = true) => {
    const { UgcSettings } = this.state;
    this.setState({ UgcSettings: { ...UgcSettings, ...data }, discardChanges: changes }, () => this.updateTheme())
  }

  themeBackground = (data, changes = true) => {
    const { background, banner, cardStyle } = this.state;
    this.setState({ cardStyle: { ...cardStyle, ...data } })
    this.setState({ background: { ...background, ...data }, discardChanges: changes, banner: banner }, () => this.updateTheme())
  }

  themeCustomCss = (data) => {
    const { CustomCss, banner } = this.state;
    this.setState({ CustomCss: { ...CustomCss, ...data }, banner: banner }, this.updateTheme)
  }

  themeSetting = (data, status = 0) => {
    const { getThemeSetting, cardStyle, banner } = this.state;
    const { themeId } = cardStyle;
    const { wallData } = this.props;

    if (status == 2) wallData['wall']['Personalization']['cssStatus'] = data.cssStatus ? 1 : 0;
    if (data.css !== undefined) wallData['wall']['Personalization']['css'] = data.css
    if (data.cssStatus !== undefined) data = { ...data, cssStatus: data.cssStatus ? 1 : 0 };
    this.setState({ getThemeSetting: { ...getThemeSetting, ...data }, themeUpdate: [69, 64, 70, 71, 72, 73].includes(themeId) ? Math.random() : 0, discardChanges: true, banner: banner, }, this.updateTheme);
  }

  activeSetting = (active, layout = 0, themeId = 0) => {
    if (layout) this.setState({ activeLayoutId: layout.index });
    this.setState({ activesettingLayout: active });
    if (themeId) {
      const { wallData, updataWallData } = this.props;
      const themeData = { ...this.state.cardStyle, id: themeId };
      wallData['wall']['Personalization']['ThemeRule']['id'] = themeId;
      updataWallData(wallData)
      this.setState({ cardStyle: themeData })
    }
  }

  updateTheme = async (status = 0, loading = 0) => {


    const { banner, background, getThemeSetting, cardStyle, themeUpdate, product, themeRender, postData, UgcSettings, newSettingUpdate } = this.state;
    const { wallData, userData } = this.props
    const themeData = {
      Background: background,
      Banner: banner,
      BannerImage: banner.BannerImage,
      CustomBannerImage: banner.CustomBannerImage,
      LogoImage: banner.LogoImage,
      Personalization: getThemeSetting,
      UgcSettings: UgcSettings,
      ThemeRule: cardStyle,
      themeUpdate: themeUpdate,
      product: product,
      themeRender: themeRender,
      isDisplay: product ? false : true,
      UgcSettings: UgcSettings
    }

    if (loading) setTimeout(() => this.setState({ loading: false }), [71, 72, 73, 74].includes(cardStyle.themeId) ? 1500 : 500);
    if (status) {

      const themeId = cardStyle.themeId;
      const wallId = getThemeSetting.wallId;
      await this.updateThemeSettings(themeId, wallId, themeData,);

      setTimeout(() => this.setState({ loading: false }), 2000);
    }

    if ((status == 1 && newSettingUpdate) || status == 0) {
      let modifiedBanner = { ...banner, CustomBannerImage: "", LogoImage: banner?.LogoImage?.newName, BannerImage: "" }
      const themeModiData = {
        Background: background,
        Banner: modifiedBanner,
        BannerImage: banner.BannerImage,
        CustomBannerImage: banner.CustomBannerImage,
        LogoImage: banner.LogoImage,
        Personalization: { ...getThemeSetting, signageTheme: cardStyle.themeId, widgetTheme: cardStyle.themeId, postAuthor: cardStyle.postAuthor, postTime: cardStyle.postTime },
        ThemeRule: {
          ...cardStyle, iconColor: cardStyle.iconColor, iconType: cardStyle.iconType, socialAction: cardStyle.socialAction,
          padding: cardStyle.padding == 0 ? 0 : cardStyle.padding,
        },
        themeUpdate: themeUpdate,
        product: product,
        themeRender: themeRender,
        isDisplay: product ? false : true,
        UgcSettings: UgcSettings
      }


      const Wall = { "id": wallData.wall.id, "name": wallData.wall.name, "status": wallData.wall.status, "owner": wallData.wall.owner, "url": wallData.wall.url, "google_tacking_status": wallData.wall.google_tacking_status, "google_tacking_code": wallData.wall.google_tacking_code, "embedTags": wallData.wall.embedTags, "defaultPost": wallData.wall?.defaultPost || 0, "dataLimit": wallData.wall?.dataLimit || 0, "isPreview": "1" }
      let newPost = wallData.postData.slice(0, Number(getThemeSetting?.numberOfPosts));
      const filteredPostdata = newPost.filter(e => {
        if ([63, 65, 66, 67, 68, 69, 71, 73].includes(cardStyle.themeId)) { return e.type != 1 }
        return true;
      })

      const sendPayload = {
        after: "eyJyZXBlYXRQb3N0IjpbIjk2NDk1NDY2MiIsIjc0MTg4OTIzMyIsIjE3OTI2MzA0MDA2OTk0ODY2IiwiMTc5Njc5ODgxNDI4MjEzMjMiLCI3NDQ5MzA3OTM4NTIwMzcwNDYzIiwiNzI2NDYwMTQxNDYyMDg0ODEyOCIsIjc5NjE5ODU5NzRfMTExNzM3MTczMzA3OTA4MCIsIjc5NjE5ODU5NzRfMTEwODg1MDMxMzkzMTIyMiIsIjc0MjY4NjMzMTYzOTMyNjY0NzUiLCIxRFRnR3RGaU5YRSIsImhEU2ZxN19zSXNrIiwiajh5eldXbGRva00iLCIxNzkxNTM2Nzg3NjAzNjMzNSIsIjE4MDE5MzIyMjYxMzYyMTQ4IiwiMTgwNDExODA4NTUyMjMzNjIiLCIxODAzNjgyODUwNjA4NTA5MiIsIjE3ODgyNTQxMDM5MTkxMjcxIiwiMTgxNDk4MTUxNTMzNDIzNTkiLCIxODA0OTgxMzYxODg4Mzc3NSIsIjE3OTA5NDYzMTczOTY1MDU3IiwiMTg0NzI5Nzc3ODQwMTUxOTUiLCIxODAyNTA0MzY4NzMxMzQ1MCIsIjc0NDk2MDA0NTYyMTg3NzQ4MjYiLCI3NDQ5NDc3ODA3MDEwMzM2MDQ2Iiwib0R1cmN4enYxXzQiLCIzeTRtN05rRk1KQSIsIjJ0YVB1NHVZMGFRIiwiWVYzbTRMc3RRTUkiLCJULThvUVZWcU4ydyIsIlRZcEFrcFoyZ2M4IiwiRWpDa0FTeWlQV3ciLCIxNzMzNzM3NDgyIiwiTDBDdkg0SWw1bjQiLCJIRkx3dE5tMjV2byIsIjZreTB4YUNlazRrIiwiMlg5dUtkLUdueWsiLCJ2akI5cTJCdk5oSSIsIm5FaWJrY2tSMzZFIiwid01FelZaWDcybTQiLCJyVmxtS0dZT3hzNCIsIm45a3BSSWx5Q2pRIl0sImxvd2VzdFRpbWUiOjE3MzI2NjEzNDl9",
        postData: filteredPostdata,
        wall: { ...themeModiData, UserRule: wallData.userRule, UserDetail: userData.UserPlan, Wall },
        customPost: null
      }

      if (this.state.debounceTimeout) { clearTimeout(this.state.debounceTimeout); }
      const timeout = setTimeout(() => {
        let checkWebsiteExist = setInterval(function () {
          let prevWallData = null;
          const personalizePreview = document.getElementById("personalizePreview");
          if (personalizePreview && !isEqual(sendPayload, prevWallData)) {
            prevWallData = { ...sendPayload };
            const message = { data: JSON.stringify({ ...sendPayload }), type: 'reloadWebsite' };
            personalizePreview?.contentWindow?.postMessage(message, '*');
          }

          clearInterval(checkWebsiteExist);
        }, 100);
        setTimeout(() => this.setState(prev => ({ ...prev, renderKey: ++prev.renderKey, themeUpdate: 0 })), 100);
      }, 300);
      this.setState({ debounceTimeout: timeout })
    }
  }


  updateThemeSettings = async (themeId, wallId, themeData) => {

    const { wallData, updataWallData } = this.props;
    const { cardStyle, getThemeSetting, background } = this.state;

    await getThemeSettings(wallId, themeId).then(response => {
      const { responseCode, responseData } = response.data;

      if (responseCode == 200) {
        const postAuthor = responseData.postAuthor;
        const postTime = responseData.postTime;
        const slideDelay = responseData.slideDelay;
        const transparent = responseData.transparent;
        const backgroundColor = responseData.backgroundColor;
        const themeChangedata = { ...cardStyle, ...responseData, themeId: responseData.themeId < 62 ? 62 : responseData.themeId };
        const backgroundUpdate = { ...background, transparent: transparent, color: backgroundColor }

        this.setState({ cardStyle: themeChangedata, getThemeSetting: { ...getThemeSetting, slideDelay: slideDelay, postAuthor: postAuthor, postTime: postTime, background: backgroundUpdate, newSettingUpdate: true } }, () => this.updateTheme());
        themeData['ThemeRule'] = themeChangedata;
        themeData['Personalization']['postAuthor'] = postAuthor;
        themeData['Personalization']['postTime'] = postTime;
        themeData['Personalization']['slideDelay'] = slideDelay;
        themeData['Background']['color'] = backgroundColor;
        themeData['Background']['transparent'] = transparent;

        wallData['wall']['Personalization']['ThemeRule'] = themeChangedata;
        wallData['wall']['Personalization']['postAuthor'] = postAuthor;
        wallData['wall']['Personalization']['postTime'] = postTime;
        wallData['wall']['Personalization']['slideDelay'] = slideDelay;
        wallData['wall']['Personalization']['ThemeRule']['transparent'] = transparent;
        wallData['wall']['Personalization']['ThemeRule']['color'] = backgroundColor;
        wallData['wall']['UgcSettings'] = themeData.UgcSettings;
        updataWallData(wallData);
      }

    }).catch(ex => {
      console.log(ex, "ex")
    })
  }


  showDiscardPop = (confirmAction, action, saveData = 0) => {
    let { bannerPrevius, backgroundPrevius, getThemeSettingPrevius, cardStylePrevius, banner, background, getThemeSetting, cardStyle, discardChanges, UgcSettings, ugcSettingsPrevius } = this.state;

    const { wallData, updataWallData } = this.props;

    if (saveData && saveData != 2) {
      if (action == 'layout' || action == 'theme-setting' || action == 'highlight' || action == 'card-style') { getThemeSettingPrevius = getThemeSetting; cardStylePrevius = cardStyle; }
      else if (action == 'background') { backgroundPrevius = background; }
      else if (action == 'banner') { bannerPrevius = banner; }
      else if (action == 'snapup') { ugcSettingsPrevius = UgcSettings; }

      wallData['wall']['Personalization'] = { ...wallData.wall.Personalization, ...getThemeSetting };
      wallData['wall']['Personalization']['ThemeRule'] = { ...wallData.wall.Personalization.ThemeRule, ...cardStyle };
      wallData['wall']['CustomBanner']['CustomBannerImage'] = banner.CustomBannerImage
      wallData['wall']['CustomBanner'] = banner;
      wallData['wall']['CustomBanner']['LogoImage'] = banner.LogoImage
      wallData['wall']['Personalization']['BannerImage'] = banner.BannerImage
      wallData['wall']['Personalization']['BackgroundImage'] = background && background.newName ? background : { "id": "", "path": "uploaded/", "newName": background.newName ? background.newName : "", "extension": "", "imgSource": "1", "status": background.newName ? "1" : "0" }

      updataWallData(wallData);

      this.setState({ discardChanges: false, getThemeSettingPrevius, cardStylePrevius, backgroundPrevius, bannerPrevius, ugcSettingsPrevius }, confirmAction);
      if (this.state.themeSettingStatus) this.onLoad()

    } else if (saveData == 2) {
      if ([1, 5, 6, 7, 4].includes(action)) { getThemeSetting = getThemeSettingPrevius; cardStyle = cardStylePrevius; }
      else if (action == 2) { background = backgroundPrevius; }
      else if (action == 3) { banner = bannerPrevius; }

      this.setState({ themeUpdate: [68, 69, 64, 67, 70, 71, 72, 73].includes(cardStyle.themeId) ? Math.random() : 0, activesettingLayout: 0, discardChanges: false, getThemeSetting, cardStyle, background, banner }, () => this.updateTheme);

    } else {

      if (discardChanges) {
        Swal.fire({
          title: "Are you sure?",
          text: "Your changes have not been saved. Do you want to save before you leave the page?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Save",
          cancelButtonText: "Discard Changes",
          reverseButtons: true,
          customClass: { confirmButton: 'btn-min-w btn', cancelButton: 'btn-min-w btn', }
        }).then((result) => {
          if (result.value) {
            if (action == 'layout' || action == 'theme-setting' || action == 'highlight' || action == 'card-style') { getThemeSettingPrevius = getThemeSetting; cardStylePrevius = cardStyle; }
            else if (action == 'background') { backgroundPrevius = background; }
            else if (action == 'banner') { bannerPrevius = banner; }
            else if (action == 'snapup') { ugcSettingsPrevius = UgcSettings; }
            this.setState({ discardChanges: false, getThemeSettingPrevius, cardStylePrevius, backgroundPrevius, bannerPrevius, ugcSettingsPrevius }, confirmAction);
          } else if (result.dismiss === "cancel") {
            if (action == 'layout' || action == 'theme-setting' || action == 'highlight' || action == 'card-style') { getThemeSetting = getThemeSettingPrevius; cardStyle = cardStylePrevius; }
            else if (action == 'background') { background = backgroundPrevius; }
            else if (action == 'banner') { banner = bannerPrevius; }
            else if (action == 'snapup') { UgcSettings = ugcSettingsPrevius; }

            this.setState({ activeLayoutId: [74, 76, 77].includes(cardStyle.themeId) ? 4 : 0, themeUpdate: [68, 69, 64, 67, 70, 71, 72, 73].includes(cardStyle.themeId) ? Math.random() : 0, activesettingLayout: 0, discardChanges: false, getThemeSetting, cardStyle, background, banner }, () => this.updateTheme(1, 0));
          }
        });
      } else {
        this.setState({ activesettingLayout: 0, discardChanges: false, activeLayoutId: 0 });
      }
    }
  }

  updateImages = (action, data) => {
    const { wallData, updataWallData } = this.props;
    let { background, banner } = this.state;
    const { bgImage, bnImg, logoIg, custombanner, customBannerStatus, customBgStatus } = data;

    if (action) {
      background['image'] = bgImage;
      wallData['wall']['Personalization']['BackgroundImage']['newName'] = bgImage; // Wall Background
      this.setState({ background }, () => updataWallData(wallData));
    } else {

      const CustomBannerImage = custombanner ? custombanner : ""
      const LogoImage = logoIg ? logoIg : ""
      const BannerImage = bnImg ? bnImg : ""

      wallData['wall']['CustomBanner']['CustomBannerImage']['newName'] = CustomBannerImage; // bannerBackground
      wallData['wall']['CustomBanner']['CustomBannerImage']['status'] = customBgStatus; // bannerBackground
      wallData['wall']['CustomBanner']['LogoImage']['newName'] = LogoImage; // banner Logo
      wallData['wall']['Personalization']['BannerImage']['newName'] = BannerImage; // custom Banner
      wallData['wall']['Personalization']['BannerImage']['status'] = customBannerStatus; // custom Banner
      banner['CustomBannerImage']['newName'] = BannerImage;
      banner['CustomBannerImage']['status'] = customBgStatus;
      banner['LogoImage']['newName'] = LogoImage;
      banner['BannerImage']['newName'] = CustomBannerImage;
      banner['BannerImage']['status'] = customBannerStatus
      this.setState({ banner }, () => updataWallData(wallData));
    }
  }

  themeSettingOnchangeStatus = (status) => { this.setState({ themeSettingStatus: status }); }
  openSidebar = () => { this.setState({ openSidebar: !this.state.openSidebar }) }

  onUpload = (onUpload, status) => {
    this.setState({ sizeError: '', onUploadPop: false })
    if (status === 'background') this.setState({ sizeError: '', onUploadPop: false })
    setTimeout(() => { this.setState({ onUploadPop: onUpload, popStatus: status }) }, 100);
  }

  bannerImageUpdate = (res) => {
    const { banner } = this.state;
    const BannerImage = { "id": "", "path": res ? "uploaded/" : "", "newName": res ? `${UPPY_BUCKET_URL}media/tmpimages/${res}` : "", "extension": res ? "" : "", "imgSource": res ? "1" : "", "status": res && banner && banner.BannerImage.status ? "1" : "" }
    this.themeBanner({ BannerImage: BannerImage })
  }

  checkUppySize = (size) => this.setState({ sizeError: size })

  themeBackgroundChange = (fileName) => {
    this.themeBackground({ image: `${UPPY_BUCKET_URL}media/tmpimages/${fileName}` })
  }

  onUppyModal = (onUppyPop, status) => {
    this.setState({ onUppyPop: false })
    setTimeout(() => { this.setState({ onUppyPop: onUppyPop, onUppyPopStatus: status }) }, 100);
  }

  logImageUpdate = (res) => {
    const bannerLogo = { "id": "", "path": res ? "uploaded/" : "", "newName": res ? `${UPPY_BUCKET_URL}media/tmpimages/${res}` : "", "extension": res ? "" : "", "imgSource": res ? "1" : "", "status": res ? "1" : "" }
    this.themeBanner({ LogoImage: bannerLogo })
  }

  customBannerUpdate = (res) => {
    const customBanner = { "id": "", "path": res ? "uploaded/" : "", "newName": res ? `${UPPY_BUCKET_URL}media/tmpimages/${res}` : "", "extension": res ? "" : "", "imgSource": res ? "1" : "", "status": res ? "1" : "" }
    this.themeBanner({ CustomBannerImage: customBanner })
  }


  reloadIfreame = () => {
    this.setState({ reloadLivePreview: true }, () => {
      setTimeout(() => {
        this.setState({ reloadLivePreview: false });
      }, 400);
    });
  };



  render() {
    const { font, layoutError, renderKey, onUploadPop, popStatus, onUppyPop, onUppyPopStatus, openSidebar, reloadLivePreview, demoWall } = this.state;
    const { wallData } = this.props;
    window.upgradeHandle = () => { this.props.togglePlanSection() }

    return wallData ? (
      <>
        <div style={{ display: 'flex' }}>
          <Helmet> {wallData.wall.Personalization.cssStatus == 1 ? <style type="text/css">{wallData.wall.Personalization.css}</style> : null} </Helmet>

          <div className={`personalize-aside bg-white ${openSidebar ? 'opensidebar' : ''}`}>
            <Button variant='' type="button" className="p-0 personalize_toggle_icon rounded-0 border-0" onClick={this.openSidebar} data-factors-form-bind="true" data-factors-click-bind="true">
              <FontAwesomeIcon type={'regular'} icon={'gear'} iconClass={'fs-4'} />
            </Button>
            <div className='personalize-inside'> <SelectLayout key={wallData.wallId} {...this.props} {...this.state} layoutError={layoutError} themeLayoutSetting={this.themeLayoutSetting} themeBackground={this.themeBackground} themeBanner={this.themeBanner} updateQrSetting={this.updateQrSetting} themeSetting={this.themeSetting} themeCustomCss={this.themeCustomCss} themecardStyle={this.themecardStyle} activeSetting={this.activeSetting} showDiscardPop={this.showDiscardPop} themeSettingStatus={this.themeSettingOnchangeStatus} updateImages={this.updateImages} onUpload={this.onUpload} bannerImageUpdate={this.bannerImageUpdate} sizeError={this.state.sizeError} onUppyModal={this.onUppyModal} logImageUpdate={this.logImageUpdate} customBannerUpdate={this.customBannerUpdate} reloadIfreame={this.reloadIfreame} /> </div>
          </div>
          <ThemeRender previewProduct={this.previewProduct} onShowDemoPost={this.onShowDemoPost} params={this.props.params} errorCode={wallData?.error_code} error={wallData?.error} {...this.state} />
          {font && <Fonts key={renderKey} />}
          {layoutError && <div className='theme_condation'> <div className='theme_condation_error'> <div className='tb_error_des'> Note: Sorry, this theme is only available for content having images or videos.</div> </div> </div>}
          {onUploadPop ? <div className="attach-file border p-1 uppy-uploader"> <PopupUpload upload={'custom-banner'} popStatus={popStatus} uploadFile={popStatus === 'background' ? this.themeBackgroundChange : this.bannerImageUpdate} onUpload={onUploadPop} setonUpload={this.onUpload} setsizeError={this.checkUppySize} /> </div> : null}
          {onUppyPop ? <ImageUpload onImgUpload={onUppyPopStatus == 'logo' ? this.logImageUpdate : this.customBannerUpdate} onUpload={onUppyPop} onUppyModal={this.onUppyModal} /> : null}
        </div>
      </>
    ) : null;
  }
}

const mapStateToProps = (state) => (
  {
    wallData: state.wallData.wallData,
    fonts: state.appsMore.fonts,
    userData: state.authenticated.userData,
    snapUpData: state.appsMore.snapUpData,
  });

const mapDispatchToProps = dispatch => {
  return {
    getFontVariants: () => dispatch(getFontVariants()),
    updataWallData: (data) => dispatch({ type: GET_WIDGET_WALL_DATA, payload: data }),
    checkNewTheme: (data, wallData, themeToApply, callBack) => dispatch(checkTheme(data, wallData, themeToApply, callBack)),
    togglePlanSection: () => dispatch(dispatch(togglePlanSection_D(true))),
    getWidgetWallData: (ownerId, wallId, callBack) => dispatch(getWidgetWallData(ownerId, wallId, callBack)),
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Personalize));